/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React from "react";

export const CompanyIcon1 = ({ className }) => {
  return (
    <svg
      className={`podjetje-icon-1 ${className}`}
      fill="none"
      height="40"
      viewBox="0 0 41 40"
      width="41"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        className="rect"
        fill="#00BABD"
        height="40"
        rx="5"
        width="40"
        x="0.300049"
      />
      <path
        className="path"
        d="M28.3001 15H12.3C11.1955 15 10.3 15.8954 10.3 17V27C10.3 28.1046 11.1955 29 12.3 29H28.3001C29.4046 29 30.3001 28.1046 30.3001 27V17C30.3001 15.8954 29.4046 15 28.3001 15Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        className="path"
        d="M24.3 29V13C24.3 12.4696 24.0893 11.9609 23.7143 11.5858C23.3392 11.2107 22.8305 11 22.3 11H18.3C17.7696 11 17.2609 11.2107 16.8858 11.5858C16.5108 11.9609 16.3 12.4696 16.3 13V29"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
};
